module.exports = __webpack_public_path__ + "img/landing-2-hu-HU.6ec8fa2.png";